<template>
  <div ref="requestVersionModal" aria-hidden="true" class="modal fade hidden" role="dialog" tabindex='-1'>
    <div class='modal-dialog modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <h5 class='modal-title mt-0'>{{ $t('request_new_version.title') }}</h5>
          <button aria-label='Close' class='close' data-dismiss='modal' type='button'>
            <span aria-hidden='true'>×</span>
          </button>
        </div>
        <form ref="requestVersion" @submit.prevent="requestVersion($event)">
          <div class="modal-body">
            <transition-expand>
              <div v-if="showOptions">
                <a href="#" class="pull-left show-options" @click.prevent="showOptions=false">
                  <i class="fa fa-long-arrow-left"></i>
                  {{ $t('version_request.back') }}
                </a>
                <version-options-form class="version-form" v-if="showOptions"
                                      :userVersionOptions="$props.userVersionOptions" :replace-now="false"
                                      @version-options-callback="versionOptionsFormCallback"/>
              </div>
            </transition-expand>

            <transition-expand>
              <div v-if="!showOptions">
                <a href="#" class="float-right show-options line" @click.prevent="showOptions=true">
                  {{ $t('version_request.edit_move_data') }}
                  <i class="fa fa-long-arrow-right"></i>
                </a>

                <div class="form-group">
                  <label>{{ $t('request_new_version.contact') }}</label>

                  <single-select :template='contactTemplate' :getter='getContacts' name='version_request[receiver_id]'
                                 v-model="contact" class='form-control'/>
                </div>

                <div class="form-group">
                  <label>{{ $t('request_new_version.message') }}</label>
                  <input type="hidden" id='version_request_message' name="version_request[message]" v-model="message"/>
                  <trix-editor input="version_request_message" :placeholder="$t('header.write_message')"></trix-editor>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6">
                      <label>
                        <input type="checkbox" name="version_request[show_old]" id="attach_previous" value="true"
                               checked="checked">
                        {{ $t('request_new_version.attach_previous') }}
                      </label>
                    </div>
                    <div class="col-md-5 offset-1">
                      <a disposition="attachment" :href="previewUrl(record.location)" class="file-name" target="_blank">
                        {{ record.filename }}
                      </a>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    <input type="hidden" name="record[skip_automatic_version_change]"
                           :value='record.skip_automatic_version_change'>
                    <input type='checkbox' :value='record.skip_automatic_version_change'
                           v-model='record.skip_automatic_version_change' name="record[skip_automatic_version_change]"/>
                    {{ $t('request_new_version.skip_auto_replace') }}
                  </label>
                </div>
              </div>
            </transition-expand>
          </div>
          <div class="modal-footer">
            <button type="button" v-if="showOptions" @click.prevent="updateOptions" :disabled="isProcessing"
                    class='btn btn-primary float-right' name='updateOptions'>
              {{ $t('header.save') }}
              <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
            </button>

            <button v-else :disabled="isDisabled || isProcessing" type="submit" value="Copy" class="btn btn-primary">
              {{ $t('request_new_version.send_request') }}
              <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import _version_options_form from '../components/records/_version_options_form'
import _single_select from './shared/_infinite_single_select'
import _transition_expand from "@/components/shared/transition_expand";
import 'trix/dist/trix'
import 'trix/dist/trix.css'

export default {
  components: {
    'single-select': _single_select,
    'version-options-form': _version_options_form,
    'transition-expand': _transition_expand,
  },
  props: {
    record: {
      required: true,
      default: () => {
        return {}
      }
    },
    userVersionOptions: {
      required: true,
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      contact: null,
      message: null,
      showOptions: false,
      versionOptions: [],
      versionOptionsSave: true,
      versionOptionsDoNothing: false,
      isProcessing: false
    }
  },
  mounted() {
    document.addEventListener("trix-change", this.setTextToTrix)
  },
  beforeDestroy() {
    document.removeEventListener("trix-change", this.setTextToTrix)
  },
  computed: {
    contacts() {
      return this.lists.contacts || []
    },

    isDisabled() {
      if (this.contact) {
        return (this.contact.email == null || this.contact.email === '')
      }
      return true
    }

  },
  methods: {
    openModal() {
      this.listStore.getContacts()
      $(this.$refs.requestVersionModal).modal('show')
      this.loadVersionOptions()
    },
    getContacts(params) {
      return this.listStore.getContacts(params)
    },
    updateOptions() {
      this.isProcessing = true
      this.store.updateUserProfile({user: {version_options: this.versionOptions}}).then(() => {
        this.$toastr.success(this.$t('version_request.options_saved'))
        this.showOptions = false
        this.isProcessing = false
      }).finally(() => {
        this.store.getCurrentUser()
      }).catch(() => {
        this.isProcessing = false
      })
    },
    requestVersion(e) {
      this.isProcessing = true

      const params = new FormData(e.target)

      if (params.get('contact_id') > 0) {
        this.$toastr.alert(this.$t('request_new_version.please_select'))
        return
      }

      if (this.versionOptionsSave)
        this.store.updateUserProfile({user: {version_options: this.versionOptions}})

      this.store.createVersionRequest(this.$props.record.id, params).then(() => {
        this.store.sendMetrics({
          name: 'request_new_version_via_email',
          params: this.$route.params,
          path: this.$route.fullPath
        })
        e.target.reset()
        this.$emit('success')
        $(this.$refs.requestVersionModal).modal('hide')
        this.$toastr.success(this.$t('version_request.request_sent'))
        this.isProcessing = false
      }).catch(() => {
        this.isProcessing = false
      })
    },
    loadVersionOptions() {
      this.store.getCurrentUser().then((data) => {
        this.versionOptions = data.user.version_options || []
      })
    },
    versionOptionsFormCallback(options, save, doNothing) {
      this.versionOptions = options
      this.versionOptionsSave = save
      this.versionOptionsDoNothing = doNothing
    },
    setTextToTrix() {
      this.message = document.getElementById("version_request_message").value
    },
  }
}
</script>
<style lang="sass" scoped>
.file-name
  width: 151px
  overflow: hidden
  text-overflow: ellipsis
  display: block

.show-options
  font-size: 14px
  color: #000
  font-weight: 400
  text-decoration: underline

.version-form
  margin-top: 15px
</style>

<style lang="sass">
trix-editor
  min-height: 150px
  max-height: 250px
  overflow: scroll
</style>
